import * as React from "react";
import { timeAgo } from "../helpers";
import { FocusFormValidator } from "./FocusFormValidator";
import { flattenData, FocusFormDataContext, FocusFormLockStatusContext, } from "./utils";
import { ButtonWithDialog, HotKeyHandler, Button, ButtonGroup, Intent, Position, Tooltip, LockButton, } from "@focus/focusUI";
import "./focusForm.scss";
import NewWindow from "react-new-window";
import { VariableList } from "../variables/VariableList";
import { SaveButton } from "./SaveButton";
import _ from "lodash";
import { ItemStatus } from "@focus/interfaces/lib/common/itemFetchStatus";
import { showContextMenu } from "./ContextMenu";
import { FocusFormMultiEdit } from "./FocusFormMultiEdit";
import { AccesibilityList } from "../accesibility/AccesibilityList";
import { FormLockStatusIcon } from "../FormLockStatusIcon";
import { addUnloadHandler } from "@focus/utils";
export class FocusFormPanel extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = (formData, change) => {
            this.props.onChange(formData, change);
            this.setState({
                hasInitialValues: false,
            });
        };
        this.handleErrorsChange = (status) => {
            this.setState({ errorsStatus: status });
        };
        this.handleReset = () => {
            this.props.onReset();
            this.setState({
                hasInitialValues: true,
            });
        };
        this.handleToggle = () => {
            if (this.props.panelLockStatus) {
                this.props.unlockPanel(this.props.formData);
                this.setState({
                    hasInitialValues: true,
                });
            }
            else {
                this.props.lockPanel(this.props.formData);
            }
        };
        this.buildVariableList = () => {
            return (React.createElement(NewWindow, { onUnload: () => this.setState({ showVariableList: false }), features: { left: 0, width: 900, height: 600, scrollbars: 1 } },
                React.createElement(VariableList, { schema: _.cloneDeep(this.props.schema), uiSchema: _.cloneDeep(this.props.uiSchema) })));
        };
        this.buildAccessList = () => {
            return (React.createElement(AccesibilityList, { config: _.cloneDeep(this.props.accessData), isOpen: this.state.showAccessList, handleOpenDialog: this.showAccessList, saveAction: this.props.saveAccessLevelConfig }));
        };
        this.handleMultiEditSave = () => {
            this.props.saveMultiEdit(this.state.changes);
        };
        this.updateChanges = (changes) => {
            this.setState({ changes });
        };
        this.isLocked = () => {
            return (this.props.modified &&
                this.props.panelLockStatus &&
                this.state.errorsStatus !== ItemStatus.ERROR);
        };
        this.listVariables = () => {
            this.setState({ showVariableList: true });
        };
        this.showAccessList = (value) => {
            this.setState({ showAccessList: value });
        };
        this.state = {
            changes: [],
            showVariableList: false,
            showAccessList: false,
            errorsStatus: null,
            hasInitialValues: true,
        };
    }
    componentDidMount() {
        addUnloadHandler(this.handleReset);
    }
    componentDidUpdate() {
        addUnloadHandler(this.handleReset);
    }
    render() {
        const { schema, uiSchema, formData } = this.props;
        const flattenedData = flattenData(schema, uiSchema, formData);
        const editMapping = {
            EDIT_PANEL: {
                fullCommand: "alt+l",
                firstKey: "alt",
                secondKey: "l",
            },
        };
        const saveMapping = {
            SAVE_PANEL: {
                fullCommand: "alt+s",
                firstKey: "alt",
                secondKey: "s",
            },
        };
        return (React.createElement(React.Fragment, null,
            " ",
            this.state.errorsStatus === ItemStatus.READY && this.isLocked() ? (React.createElement(HotKeyHandler, { keyMapping: saveMapping, onCall: () => this.props.onSave(this.props.formData) })) : null,
            React.createElement("div", { className: "program-header", key: "header" },
                React.createElement("div", { className: "program-label" },
                    React.createElement("label", null, this.props.schema.title || this.props.title),
                    this.props.lastModificationDate ? (React.createElement(Tooltip, null,
                        React.createElement("div", { className: "program-label_modification" }, `last edited : ${timeAgo(this.props.lastModificationDate)}`))) : null,
                    this.props.operationalPanelAvailable ? (!this.props.panelRefStatus ? (React.createElement(Tooltip, { content: "Panel data is different from the one referred to as operational", position: Position.TOP },
                        React.createElement("span", { className: "panel-ref-status-label" }, "modified"))) : (React.createElement(Tooltip, { content: "Panel data is the same as the one referred to as operational", position: Position.TOP },
                        React.createElement("span", { className: "panel-ref-status-label-ok" }, "baseline")))) : null,
                    this.props.lockPanel ? (React.createElement(FormLockStatusIcon, { lockStatus: this.props.panelLockStatus })) : null),
                !this.props.hideTools && (React.createElement("div", { className: "program-button_container" },
                    React.createElement(HotKeyHandler, { keyMapping: editMapping, onCall: this.handleToggle }),
                    React.createElement("div", { className: "program-button", key: "button" },
                        React.createElement(ButtonGroup, null,
                            React.createElement(SaveButton, { onSave: () => {
                                    this.props.onSave(this.props.formData);
                                }, locked: this.isLocked(), validationStatus: this.state.errorsStatus, status: this.props.saveStatus }),
                            React.createElement(ButtonWithDialog, { intent: Intent.NONE, form: () => "All changes will be lost", icon: "undo", text: "Discard", onAccept: this.handleReset, disabled: !this.props.panelLockStatus || !this.props.modified }),
                            this.props.multiEdit && (React.createElement(ButtonWithDialog, { disabled: this.props.multiEditConfigStatus !== ItemStatus.READY, intent: Intent.NONE, form: () => (React.createElement(FocusFormMultiEdit, { schema: this.props.schema, uiSchema: this.props.uiSchema, formData: this.props.formData, multiEditConfig: this.props.multiEditConfig, onChange: this.updateChanges })), icon: "manually-entered-data", text: "Multi", style: { width: "80%" }, onAccept: this.handleMultiEditSave })),
                            this.props.lockPanel ? (React.createElement(LockButton, { locked: this.props.panelLockStatus, onClick: this.handleToggle, hasInitialValues: this.state.hasInitialValues })) : null,
                            this.props.operationalPanelAvailable ? (React.createElement(React.Fragment, null,
                                React.createElement(Button, { intent: Intent.NONE, onClick: this.props.setOperational, text: "Operational", icon: "folder-shared-open", disabled: !this.props.readOnly }),
                                React.createElement(Button, { onClick: this.props.restoreOperational, text: "Restore", icon: "history", title: "Restore to operational reference", disabled: this.props.panelRefStatus }))) : null))))),
            React.createElement("div", { className: "form-container", key: `container${this.props.keyParam ? "_" + this.props.keyParam : null}`, onContextMenu: showContextMenu(this.listVariables, {
                    accessData: this.props.accessData,
                    showAccessList: this.showAccessList,
                }) },
                React.createElement(FocusFormDataContext.Provider, { value: flattenedData },
                    React.createElement(FocusFormLockStatusContext.Provider, { value: {
                            hidden: this.props.hideTools || !this.props.lockPanel,
                            lockStatus: this.props.panelLockStatus,
                            handleLock: this.handleToggle,
                            hasInitialValues: this.state.hasInitialValues,
                        } },
                        React.createElement(FocusFormValidator, { key: "validation", schema: this.props.schema, uiSchema: this.props.uiSchema, formData: this.props.formData, readOnly: this.props.readOnly, needsDefaults: this.state.hasInitialValues, onChange: this.handleChange, onErrorsChange: this.handleErrorsChange })))),
            this.state.showVariableList && this.buildVariableList(),
            this.state.showAccessList && this.buildAccessList()));
    }
}
//# sourceMappingURL=FocusFormPanel.js.map